import { useCustomEventEffect } from '../hooks/useCustomEventEffect';

function dispatch<T = any>(identifier: string, detail?: T) {
  document.dispatchEvent(new CustomEvent<T>(identifier, { detail }));
}

const onSelectionTarget = (identifier: string) => `reactTable:${identifier}:onSelection`;
export function dispatchTableOnSelectionEvent<T extends any[]>(identifier: string, selection: T) {
  return dispatch<T>(onSelectionTarget(identifier), selection);
}
export function useTableOnSelectionEventEffect<T extends any[]>(
  identifier: string,
  callback: (event: CustomEvent<T>) => any,
) {
  return useCustomEventEffect(onSelectionTarget(identifier), callback);
}

const clearSelectionTarget = (identifier: string) => `reactTable:${identifier}:clearSelection`;
export function dispatchTableClearSelectionEvent(identifier: string) {
  return dispatch(clearSelectionTarget(identifier));
}
export function useTableClearSelectionEventEffect(identifier: string, callback: () => any) {
  return useCustomEventEffect(clearSelectionTarget(identifier), callback);
}

const onActionEndTarget = (identifier: string) => `reactTable:${identifier}:onActionEnd`;
export function dispatchTableOnActionEndEvent(identifier: string) {
  return dispatch(onActionEndTarget(identifier));
}
export function useTableOnActionEndEventEffect(identifier: string, callback: () => any) {
  return useCustomEventEffect(onActionEndTarget(identifier), callback);
}

const onInitialisedTarget = (identifier: string) => `reactTable:${identifier}:onInitialised`;
export function dispatchTableOnInitialisedEvent(identifier: string) {
  return dispatch(onInitialisedTarget(identifier));
}
export function useTableOnInitialisedEventEffect(identifier: string, callback: () => any) {
  return useCustomEventEffect(onInitialisedTarget(identifier), callback);
}

const onLanesInitialisedTarget = (identifier: string) => `${identifier}:lane:initialised`;
export function dispatchLaneOnInitialisedEvent(identifier: string) {
  return dispatch(onLanesInitialisedTarget(identifier));
}
export function useLanesOnInitialisedEventEffect(identifier: string, callback: () => any) {
  return useCustomEventEffect(onLanesInitialisedTarget(identifier), callback);
}

const fetchDataTarget = (identifier: string) => `reactTable:${identifier}:fetchData`;
export function dispatchTableFetchDataEvent(identifier: string, resetPageNumber: boolean) {
  return dispatch(fetchDataTarget(identifier), resetPageNumber);
}
export function useTableFetchDataEventEffect(
  identifier: string,
  callback: (event: CustomEvent<{ resetPageNumber: boolean }>) => any,
) {
  return useCustomEventEffect(fetchDataTarget(identifier), callback);
}
export function addTableFetchDataEventListener(identifier: string, callback: () => any) {
  document.addEventListener(fetchDataTarget(identifier), callback);
}
export function removeTableFetchDataEventListener(identifier: string, callback: () => any) {
  document.removeEventListener(fetchDataTarget(identifier), callback);
}

const allFetchDataTarget = 'reactTable:fetchData';
export function dispatchTableAllFetchDataEvent(resetPageNumber: boolean) {
  return dispatch(allFetchDataTarget, resetPageNumber);
}
export function useTableAllFetchDataEventEffect(callback: (event: CustomEvent<{ resetPageNumber: boolean }>) => any) {
  return useCustomEventEffect(allFetchDataTarget, callback);
}
export function addTableAllFetchDataEventListener(callback: () => any) {
  document.addEventListener(allFetchDataTarget, callback);
}
export function removeTableAllFetchDataEventListener(callback: () => any) {
  document.removeEventListener(allFetchDataTarget, callback);
}
const onIdChangeTarget = (identifier: string) => `reactTable:${identifier}:idsChange`;
export function dispatchTableOnIdsChange<T extends any[]>(identifier: string, recordsIds: T) {
  return dispatch<T>(onIdChangeTarget(identifier), recordsIds);
}
